import type { FullAirHandlerUnit } from "@eisox/api/core-api";
import { withForm } from "@eisox/form";

import {
  MAXIMUM_ANTI_FREEZE_ALARM_SETPOINT,
  MAXIMUM_OUTSIDE_AIR_DAMPERS_SETPOINT,
  MINIMUM_ANTI_FREEZE_ALARM_SETPOINT,
  MINIMUM_OUTSIDE_AIR_DAMPERS_SETPOINT,
  STEP,
} from "~/constants/air-handler-unit.constant";
import { m } from "~/paraglide/messages";

import { setpointFormOptions } from "../helpers";
import { DiscrepancyLabel } from "./discrepancy-slider";

/** The general settings section shows up as soon as the CTA reports one of its two settings. */
export const hasGeneralSetpoints = (airHandlerUnit: FullAirHandlerUnit) =>
  airHandlerUnit.minimumOutsideAirDampersSetpoint !== undefined || airHandlerUnit.antiFreezeAlarmSetpoint !== undefined;

/** The minimum opening of the fresh air damper and the anti-freeze alarm, each when reported. */
const SetpointGeneralSection = withForm({
  ...setpointFormOptions,
  props: {} as { airHandlerUnit: FullAirHandlerUnit },
  render: function Render({ form, airHandlerUnit }) {
    return (
      <div className="gap-2.5 flex flex-col">
        {airHandlerUnit.minimumOutsideAirDampersSetpoint !== undefined && (
          <form.AppField name="minimumOutsideAirDampersSetpoint">
            {field => (
              <field.Slider
                classNames={{ control: "w-full", value: "w-16 justify-end" }}
                label={
                  <DiscrepancyLabel
                    label={`${m.minimum_outside_air_dampers_setpoint()} (%)`}
                    property="minimumOutsideAirDampersSetpoint"
                  />
                }
                min={MINIMUM_OUTSIDE_AIR_DAMPERS_SETPOINT}
                max={MAXIMUM_OUTSIDE_AIR_DAMPERS_SETPOINT}
                step={STEP}
              />
            )}
          </form.AppField>
        )}
        {airHandlerUnit.antiFreezeAlarmSetpoint !== undefined && (
          <form.AppField name="antiFreezeAlarmSetpoint">
            {field => (
              <field.Slider
                classNames={{ control: "w-full", value: "w-16 justify-end" }}
                label={
                  <DiscrepancyLabel
                    label={`${m.anti_freeze_alarm_setpoint()} (°C)`}
                    property="antiFreezeAlarmSetpoint"
                  />
                }
                min={MINIMUM_ANTI_FREEZE_ALARM_SETPOINT}
                max={MAXIMUM_ANTI_FREEZE_ALARM_SETPOINT}
                step={STEP}
              />
            )}
          </form.AppField>
        )}
      </div>
    );
  },
});

export { SetpointGeneralSection };
